import { render } from "./tags-inline.vue?vue&type=template&id=53b896bc&ts=true"
import script from "./tags-inline.vue?vue&type=script&lang=ts"
export * from "./tags-inline.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__